// extracted by mini-css-extract-plugin
export default {"menu_banner":"puk_MB_0xlK5HChOXL3Q","menuBanner":"puk_MB_0xlK5HChOXL3Q","menu_brands":"km283pAgN_kxRG3XSbyv","menuBrands":"km283pAgN_kxRG3XSbyv"};